import { CodeIcon } from "lucide-react";

import BasePreview from "@/components/builder/blocks/base";
import { prop, define, useCustomProp } from "@/components/builder/utils";

import { DroppablePlaceholder } from "../utils/Placeholder";

function TagPreview({ children, properties: { tagName: Tag, ...properties }, ...props }) {
  const { value: suppressChildren } = useCustomProp('suppressChildren')

  if (suppressChildren) return <BasePreview properties={properties} {...props} ><Tag /></BasePreview>

  children = children || <DroppablePlaceholder>
    Drop here
  </DroppablePlaceholder>

  return <BasePreview properties={properties} {...props} >
    <Tag onClick={e => e.preventDefault()}>
      {children}
    </Tag>
  </BasePreview>
}

export default define('tag', TagPreview)
  .canvas()
  .tag({ propTagName: 'tagName' })
  .palete(<CodeIcon size={16} />, 'Tag', 'Advanced')
  .property(prop.predefined.customClass())
  .property(...prop.predefined.layout())
  .property(...prop.predefined.borders())
  .property(...prop.predefined.appearance())
  .property(prop.select.creatable('Tag', 'tagName')
    .own()
    .blockClear()
    .category('default')
    .options(prop.options()
      .add('div', 'div')
      .add('span', 'span')))
  .property(prop.predefined.attributes())
  .showOnAddProps(...prop.predefined.image())
  .defaultProps({
    tagName: 'div',
  })
  .build()
